import { render, staticRenderFns } from "./EventCreateLogos.vue?vue&type=template&id=10bee315&"
import script from "./EventCreateLogos.vue?vue&type=script&lang=js&"
export * from "./EventCreateLogos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/forge/staging.portal.letsreimagine.org/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('10bee315')) {
      api.createRecord('10bee315', component.options)
    } else {
      api.reload('10bee315', component.options)
    }
    module.hot.accept("./EventCreateLogos.vue?vue&type=template&id=10bee315&", function () {
      api.rerender('10bee315', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/events/steps/EventCreateLogos.vue"
export default component.exports